export const API_ORIGIN = (() => {
  return process.env.PREACT_APP_API_ORIGIN || "";
})();
